import type {Token} from '../token'

/**
 * Expand any opening `codeFencedFence` to include the following newline, so that when we hide the delimiter we don't
 * leave a blank line at the beginning of the code block.
 */
export function expandOpenCodeFences(tokens: Token[]): void {
  for (const [i, token] of tokens.entries())
    if (token.type === 'codeFenced' && token.direction === 'enter') {
      const openFenceEnterToken = tokens[i + 1]

      const openFenceExitIndex = tokens.findIndex(t => t.type === 'codeFencedFence' && t.direction === 'exit', i + 1)
      const openFenceExitToken = tokens[openFenceExitIndex]

      const lineEndingEnterToken = tokens[openFenceExitIndex + 1]
      const lineEndingExitToken = tokens[openFenceExitIndex + 2]

      if (
        !openFenceEnterToken ||
        !openFenceExitToken ||
        lineEndingEnterToken?.type !== 'lineEnding' ||
        lineEndingExitToken?.type !== 'lineEnding'
      )
        continue

      // Expand the end of the fence token to include the line ending char
      openFenceEnterToken.end++
      openFenceExitToken.end++

      // Rearrange from: `codeFencedFence.exit, lineEnding.enter, lineEnding.exit`
      // to: `lineEnding.enter, lineEnding.exit, codeFencedFence.exit`
      tokens.splice(openFenceExitIndex, 3, lineEndingEnterToken, lineEndingExitToken, openFenceExitToken)
    }
}
